import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import DemoLayout from "@/components/DemoLayout";
import ErrorBoundary from "@/components/ErrorBoundary";
import LoginPage from "@/pages/LoginPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import HomePage from "@/pages/HomePage";
import DashboardPage from "@/pages/DashboardPage";
import TicketDetailPage from "@/pages/TicketDetailPage";
import AnagrafichePage from "@/pages/AnagrafichePage";
import CalendarioPage from "@/pages/CalendarioPage";
import FeedbackPage from "@/pages/FeedbackPage";
import IpotesiPage from "@/pages/IpotesiPage";
import UsersAdminPage from "@/pages/UsersAdminPage";
import AuditLogPage from "@/pages/AuditLogPage";

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Caricamento…</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (user.must_change_password && loc.pathname !== "/change-password")
    return <Navigate to="/change-password" replace />;
  return children;
}

function RequireRole({ roles, children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/change-password" element={<RequireAuth><ChangePasswordPage /></RequireAuth>} />
          <Route path="/" element={<RequireAuth><DemoLayout /></RequireAuth>}>
            <Route index element={<HomePage />} />
            <Route path="ticket" element={<DashboardPage />} />
            <Route path="ticket/:id" element={<TicketDetailPage />} />
            <Route path="calendario" element={<CalendarioPage />} />
            <Route path="anagrafiche" element={<AnagrafichePage />} />
            <Route path="feedback" element={<FeedbackPage />} />
            <Route path="ipotesi" element={<IpotesiPage />} />
            <Route path="admin/utenti" element={<RequireRole roles={["OWNER"]}><UsersAdminPage /></RequireRole>} />
            <Route path="admin/audit" element={<RequireRole roles={["OWNER"]}><AuditLogPage /></RequireRole>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
